import { useTranslation } from "react-i18next";
import { Music } from "lucide-react";
import { FaTiktok } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="bg-white/80 backdrop-blur-lg border border-white/30 py-2">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-2">
        <div className="mb-2 md:mb-0">© {t("buildWithLove")}</div>

        <div className="flex items-center gap-4">
          <a
            href="/articles"
            className="hover:underline"
          >
            Articles
          </a>
          <span className="text-gray-400">|</span>
          <a
            href="https://fluencylock.com"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 hover:underline"
          >
            <Music className="h-4 w-4" />
            {t("try")} FluencyLock
            <span className="sr-only">(opens in new tab)</span>
          </a>

          <a
            href="https://www.instagram.com/fluencylock/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <FiInstagram
              className="h-4 w-4 hover:text-pink-500"
              aria-hidden="true"
              focusable="false"
            />
            <span className="sr-only">(opens in new tab)</span>
          </a>

          <a
            href="https://www.tiktok.com/@fluencylock"
            target="_blank"
            rel="noopener noreferrer"
            aria-describedby="tiktok-description"
          >
            <FaTiktok
              className="h-4 w-4 hover:text-black"
              aria-hidden="true"
              focusable="false"
            />
            <span id="tiktok-description" className="sr-only">
              Follow us on TikTok (opens in new tab)
            </span>
          </a>
        </div>
      </div>
    </footer>
  );
}
